import { Strategy as StrategyType } from './utils'
import Styles from './StrategiesSelection.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { pluralize } from 'utils'

export interface StrategyValuesMobileProps {
  strategy: StrategyType
}

export const StrategyValuesMobile = ({ strategy }: StrategyValuesMobileProps) => {
  const seoContentsCount = strategy.seo_contents.find((content) => content.type === 'blog_post')?.count || 0
  const newsletterContentsCount = strategy.email_contents.find((content) => content.type === 'newsletter')?.count || 0
  const crosspostContentsCount = strategy.crosspost_contents.find((content) => content.type === 'post')?.count || 0
  const videoCrosspostContentsCount =
    strategy.video_crosspost_contents.find((content) => content.type === 'post')?.count || 0

  return (
    <div className={Styles.strategyValues}>
      {crosspostContentsCount > 0 && (
        <>
          <div className={Styles.strategyValue}>
            <Text variant="secondary">
              <span className={Styles.strategyValueCount}>{crosspostContentsCount}</span>{' '}
              {pluralize('Post', crosspostContentsCount)}
            </Text>
          </div>
          <div className={Styles.separator} />
        </>
      )}
      {videoCrosspostContentsCount > 0 && (
        <>
          <div className={Styles.strategyValue}>
            <Text variant="secondary">
              <span className={Styles.strategyValueCount}>{videoCrosspostContentsCount}</span>{' '}
              {pluralize('Video', videoCrosspostContentsCount)}
            </Text>
          </div>
          <div className={Styles.separator} />
        </>
      )}
      {newsletterContentsCount > 0 && (
        <>
          <div className={Styles.strategyValue}>
            <Text variant="secondary">
              <span className={Styles.strategyValueCount}>{newsletterContentsCount}</span>{' '}
              {pluralize('Email', newsletterContentsCount)}
            </Text>
          </div>
          {seoContentsCount > 0 && <div className={Styles.separator} />}
        </>
      )}
      {seoContentsCount > 0 && (
        <>
          <div className={Styles.strategyValue}>
            <Text variant="secondary">
              <span className={Styles.strategyValueCount}>{seoContentsCount}</span>{' '}
              {pluralize('Blog', seoContentsCount)}
            </Text>
          </div>
        </>
      )}
    </div>
  )
}
